export const landingPageSEO = {
  title: "Christ Reigns - Your Personal Bible Study Dashboard | Christian Growth Platform",
  description: "Transform your Bible study with Christ Reigns - the ultimate Christian dashboard featuring AI-powered Bible chat, personalized growth tracking, study plans, and comprehensive biblical resources. Start your spiritual journey today.",
  keywords: [
    "bible study dashboard",
    "christian growth tracker",
    "bible study app",
    "christian dashboard",
    "bible reading plan",
    "christian apologetics",
    "bible study progress",
    "spiritual growth tracker",
    "bible chat ai",
    "christian study tools",
    "bible gateway integration",
    "youversion bible",
    "biblical resources",
    "scripture study",
    "christian education",
    "bible verse search",
    "faith journey tracker"
  ],
  canonicalUrl: "https://christreignslab.com",
  ogImage: "https://christreignslab.com/thumbnails/christ-reigns-dashboard.png",
  structuredData: {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Christ Reigns Media",
    "description": "Sharing the Gospel, equipping believers and Personal Bible Study Dashboard and Christian Growth Platform",
    "url": "https://christreignslab.com",
    "applicationCategory": "EducationalApplication",
    "operatingSystem": "Web Browser",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "featureList": [
      "Bible Study Dashboard",
      "AI-Powered Bible Chat",
      "Personal Growth Tracking",
      "Bible Reading Plans",
      "Christian Apologetics Resources",
      "Progress Tracking",
      "Multiple Bible Versions"
    ],
    "screenshot": "https://christreignslab.com/thumbnails/christ-reigns-dashboard.png"
  }
};

export const landingPageFeatures = [
  {
    title: "AI-Powered Bible Chat",
    description: "Get instant biblical answers and insights through our intelligent AI assistant trained on scripture and Christian theology.",
    icon: "💬",
    benefits: ["Instant biblical answers", "Contextual scripture insights", "24/7 spiritual guidance"]
  },
  {
    title: "Personal Growth Tracking",
    description: "Set spiritual goals, track your Bible reading progress, and receive personalized recommendations for your faith journey.",
    icon: "📈",
    benefits: ["Customizable spiritual goals", "Reading progress tracking", "Personal recommendations"]
  },
  {
    title: "Comprehensive Bible Study",
    description: "Access multiple Bible versions, study tools, and resources all in one integrated dashboard.",
    icon: "📖",
    benefits: ["Multiple Bible versions", "Integrated study tools", "Cross-references and notes"]
  },
  {
    title: "Apologetics Resources",
    description: "Strengthen your faith with curated apologetics materials, books, and study guides from various resources online all in one place here.",
    icon: "🛡️",
    benefits: ["Curated apologetics content", "Defense of faith resources", "Study guides and books"]
  },
  {
    title: "Reading Plans & Reminders",
    description: "Stay consistent with customizable reading plans and smart reminders for your spiritual disciplines.",
    icon: "⏰",
    benefits: ["Customizable reading plans", "Smart reminders", "Habit tracking"]
  },
  {
    title: "Progress Analytics",
    description: "Visualize your spiritual growth with detailed analytics and progress reports.",
    icon: "📊",
    benefits: ["Visual progress reports", "Growth analytics", "Achievement tracking"]
  },
  {
    title: "Journal Entries & Notes",
    description: "Document your spiritual insights, prayer requests, and personal reflections with our integrated journaling system.",
    icon: "📝",
    benefits: ["Personal reflection space", "Prayer request tracking", "Spiritual insights logging"]
  },
  {
    title: "Favorite Bible Verses",
    description: "Save, organize, and revisit your most meaningful Bible verses with personal notes and categorization.",
    icon: "💖",
    benefits: ["Verse bookmarking", "Personal categorization", "Quick access to favorites"]
  },
  {
    title: "App Assistant AI",
    description: "Ask anything about the app — features, resources, navigation & more with our fast Groq & Llama powered assistant.",
    icon: "🤖",
    benefits: ["Instant feature & navigation guidance", "Powered by Groq • Llama technology", "Quick prompt suggestions & voice input"]
  },
  {
    title: "Media and Learning",
    description: "Access the latest teaching, evangelism, and apologetics videos from trusted Christian scholars, apologists, and ministers.",
    icon: "🎬",
    benefits: ["Over 200+ curated sermons & apologetics videos", "Filter by trusted creators & ministries", "Categorized by topic and personal watch history"]
  },
  {
    title: "Biblical Theology Profile",
    description: "Discover your theological convictions in the light of Scripture and explore alignment with historic Christian traditions.",
    icon: "📜",
    benefits: ["Sola Scriptura scriptural & pastoral synthesis", "Historic confessions & tradition alignment", "Comprehensive theological conviction harmony"]
  }
];

export const testimonials = [
  {
    name: "Maria Lopez Jimenez",
    role: "Bible Study Enthusiast",
    content: "Christ Reigns has transformed how I prepare for Bible studies. The AI chat feature helps me find relevant scriptures instantly, and the progress tracking keeps me accountable. I love the simple but easy friendly UI that's not cluttered or overwhelming.",
    rating: 5
  },
  {
    name: "Michael Chen",
    role: "Seminary Student",
    content: "As a seminary student, this dashboard is invaluable. The apologetics resources found here are very convenient to have them all in one place for easy access and multiple Bible versions in one place save me time to flip to different sites and resourcs. I love that it's all here within easy access.",
    rating: 5
  },
  {
    name: "Rebecca Martinez",
    role: "Small Group Leader",
    content: "I love the Growth Profile! It is so useful to have something that will tell you where you are, what you want to focus on whether it's more from the apologetics side or theology side and it analyzes your goals and guides you the best recommended resources, love that! ",
    rating: 5
  }
];